<template>
    <va-create-layout>
        <RefundEventOrderCharge-form
            :title="title"
            :item="item"
        ></RefundEventOrderCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
